import dayjs, { type Dayjs, OptionType } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
import i18next from '../i18n';

export const isTypeObject = (param: unknown) => typeof param === 'object' && param !== null;

export const checkDateFormatIsValid = (date: string | Date | Dayjs) => dayjs(date).isValid();

export const convertDateAccordingToDatePickerFormat = (
  date: string | Date | Dayjs,
  format?: OptionType
) => dayjs(date, format);

export const convertDateAccordingToBackendFormat = (date: string | Date | Dayjs) =>
  dayjs(date, 'DD.MM.YYYY', true).format('YYYY-MM-DD');

export const convertDateAccordingToFrontendFormat = (date: string | Date | Dayjs) =>
  dayjs(date).format('DD.MM.YYYY');

export function a11yProps(idx: number) {
  return {
    id: `tab-${idx}`,
    'aria-controls': `tabpanel-${idx}`,
  };
}

export const getLanguageId = (languageCode?: 'tr' | 'en') => {
  if (languageCode) {
    return languageCode === 'tr' ? 1 : 2;
  }

  return i18next.resolvedLanguage === 'tr' ? 1 : 2;
};

export const getDataByLanguageId = <T>(data: T[], languageId?: 1 | 2): T => {
  if (languageId) {
    //@ts-expect-error must have languageId in data
    return data?.find((item) => item.languageId === languageId) ?? data[0];
  }

  return (
    //@ts-expect-error must have languageId in data
    data?.find((item) => item.languageId === getLanguageId(i18next.resolvedLanguage as 'tr' | 'en')) ??
    data[0]
  );
};

interface ConvertFileToBase64 {
  (file: Blob, withType?: boolean): Promise<string | void>;
}

export const convertFileToBase64: ConvertFileToBase64 = (file, withType = false) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    if (!file) {
      console.error('no file');
    } else {
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        if (fileReader.result) {
          if (typeof fileReader.result !== 'string') {
            console.error('result is not string', typeof fileReader.result, fileReader.result);
          } else {
            return withType
              ? resolve(fileReader.result)
              : resolve(fileReader.result.split('base64,')[1]);
          }
        }
      };
    }
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

type MobileOS = 'iPhone' | 'Android' | 'iPad';

export const getMobileOS = () => {
  const os: MobileOS[] = ['iPhone', 'Android', 'iPad'];
  return os.find((v) => navigator.userAgent.indexOf(v) >= 0);
};

